"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const array_1 = require("../../common/js/helper/array");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class Countries {
    api = new ecommerce_1.CountryApi(configuration_1.default);
    countryList = [];
    bucketList = [];
    internalIsLoading = false;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            bucketList: mobx_1.observable,
            buckets: mobx_1.computed,
            countries: mobx_1.computed,
            countryList: mobx_1.observable,
            countryOptions: mobx_1.computed,
            internalIsLoading: mobx_1.observable,
            isLoading: mobx_1.computed,
            loadAllCountries: mobx_1.action.bound,
            registrationCountries: mobx_1.computed,
        });
    }
    get isLoading() {
        return this.internalIsLoading;
    }
    get registrationCountries() {
        return this.countries
            .filter((country) => {
            if (!country || !country.iso) {
                return false;
            }
            return country.extensions?.massiveCountry?.availableForRegistration ?? false;
        })
            .map((country) => {
            return {
                value: country.iso,
                label: country.translated?.name ?? country.iso,
            };
        });
    }
    get countries() {
        return this.countryList;
    }
    get buckets() {
        return this.bucketList;
    }
    get countryOptions() {
        return this.countries.map((country) => {
            return {
                value: country.iso,
                label: country.translated?.name ?? country.iso,
            };
        });
    }
    countryStateOptions(countryCode) {
        const countrySelected = this.getCountryByCode(countryCode);
        if (!countrySelected?.states?.length) {
            return null;
        }
        const uniqueStates = new Map();
        countrySelected.states.map((state) => {
            uniqueStates.set(state.shortCode, { value: state.shortCode.split('-')[1], label: state.translated?.name });
        });
        return Array.from(uniqueStates.values());
    }
    getCountryByCode(countryCode) {
        return (0, array_1.first)(this.countryList.filter((country) => country.iso === countryCode)) ?? null;
    }
    loadAllCountries() {
        this.internalIsLoading = true;
        return this.api
            .readAllCountries()
            .then((list) => {
            this.countryList = list.elements;
            this.bucketList = list.aggregations.countZxxResponsibleSalesChannelsPerCountry.buckets;
        })
            .finally(() => {
            this.internalIsLoading = false;
        });
    }
}
__decorate([
    bind_decorator_1.default
], Countries.prototype, "getCountryByCode", null);
exports.default = new Countries();
